import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MapPinIcon, XIcon } from 'lucide-react';
import { CHECKOUT_URL, PRODUCT_IMAGE, PRODUCT_NAME, recentBuyers } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyers.length);
      }, 5500);
    };
    const first = setTimeout(show, 7000);
    const interval = setInterval(show, 16000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-44" data-mp="164xtdbviverf">
      <AnimatePresence data-id="element-45" data-mp="116d1bzqfc1e2">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative w-full overflow-hidden rounded-xl border border-accent-500/60 bg-carbon-900 shadow-2xl shadow-black sm:w-[23rem]" data-id="element-46" data-mp="1fviyzj9m5jju">
            <span className="absolute inset-y-0 left-0 w-1 bg-accent-500" aria-hidden="true" data-id="element-47" data-mp="s67tjohbj0zd" />
            <a href={CHECKOUT_URL} onClick={trackInitiateCheckout} className="flex items-center gap-3 p-3 pl-4 pr-9 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-accent-400/60" data-id="element-48" data-mp="s8kjoox8chni">
              <img src={PRODUCT_IMAGE} alt="" className="h-14 w-16 shrink-0 rounded-md bg-carbon-800 object-contain p-0.5" data-id="element-49" data-mp="2aotia7mktlfi" />
              <div className="min-w-0 text-sm leading-snug" data-id="element-50" data-mp="2fmmoh0nvqffs">
                <p className="flex items-center gap-1.5 font-display text-sm font-bold uppercase tracking-wide text-accent-400" data-id="element-51" data-mp="2kmr5qswm3e72">
                  <span className="h-2 w-2 rounded-full bg-accent-400" aria-hidden="true" data-id="element-52" data-mp="2pm3uxkaygxct" />
                  Compra reciente
                </p>
                <p className="mt-0.5 text-carbon-100" data-id="element-53" data-mp="1rvz2xcl1jrar">
                  <span className="font-semibold text-white" data-id="element-54" data-mp="1wwd9eq6zut6o">{buyer.name}</span> compró el{' '}
                  <span className="font-semibold text-accent-300" data-id="element-55" data-mp="21vzo742h0hhl">{PRODUCT_NAME}</span>
                </p>
                <p className="mt-1 flex items-center gap-1 text-xs text-carbon-400" data-id="element-56" data-mp="26o19tglj3kka">
                  <MapPinIcon className="h-3.5 w-3.5 shrink-0 text-accent-500" aria-hidden="true" data-id="element-57" data-mp="1983so2on0vme" />
                  {buyer.city}, {buyer.province} · Argentina
                </p>
              </div>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-carbon-500 transition-colors duration-150 hover:text-carbon-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400/50" data-id="element-58" data-mp="3rfx2padw9jvs">
              <XIcon className="h-4 w-4" data-id="element-59" data-mp="3dhypw9f81vie" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}